import type { SharedPhoto } from '../types/SharedCollection';

/** Parse `?photos=id1,id2` (comma-separated Firestore photo ids). */
export function parsePhotosQueryString(photosParam: string | null): string[] | null {
   if (!photosParam?.trim()) return null;
   const parts = photosParam
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
   return parts.length ? parts : null;
}

/**
 * When `queryIds` is set, keep only photos whose `id` or `originalPhotoId` appears in the list.
 * Returns ids that were requested but not found (for a soft warning).
 */
export function filterSharedPhotosByQueryIds(
   photos: SharedPhoto[],
   queryIds: string[] | null,
): { displayPhotos: SharedPhoto[]; missingIds: string[] } {
   if (!queryIds?.length) {
      return { displayPhotos: photos, missingIds: [] };
   }
   const want = new Set(queryIds);
   const displayPhotos = photos.filter(
      (p) => want.has(p.id) || want.has(p.originalPhotoId),
   );
   const matched = new Set<string>();
   for (const p of displayPhotos) {
      matched.add(p.id);
      matched.add(p.originalPhotoId);
   }
   const missingIds = queryIds.filter((id) => !matched.has(id));
   return { displayPhotos, missingIds };
}
